import { useState, useEffect } from 'react';
import { Table, Input } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';

const { Search } = Input;

const firmwareHistoryColumns = [
    {
        title: 'Firmware Version',
        dataIndex: 'version',
        key: 'version',
    },
    {
        title: 'Details',
        dataIndex: 'details',
        key: 'details',
        render: (details) => details && details !== '' ? details : 'N/A',
    },
];

const toFirmwareHistoryRows = (firmwareVersions) => {
    if (!firmwareVersions || firmwareVersions.length === 0) return [];
    const rows = [];
    [...firmwareVersions].reverse().forEach((entry) => {
        Object.keys(entry).reverse().forEach((version) => {
            rows.push({ version, details: entry[version] });
        });
    });
    return rows.map((row, index) => ({ ...row, key: index }));
};

const getLatestFirmwareVersion = (firmwareVersions) => {
    if (!firmwareVersions || firmwareVersions.length === 0) return null;
    const lastEntry = firmwareVersions[firmwareVersions.length - 1];
    const keys = Object.keys(lastEntry);
    return keys.length > 0 ? keys[keys.length - 1] : null;
};

const PublicChargerFirmwareTable = () => {
    const [chargers, setChargers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [serialSearch, setSerialSearch] = useState('');
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 5,
    });

    const fetchChargers = async (page = 1, pageSize = 5, serial = serialSearch) => {
        try {
            setIsLoading(true);
            const res = await BreathAPIs.getPublicChargerFirmwareList(page, pageSize, serial || null);
            setChargers(res.data.chargers || []);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
            });
        } catch (error) {
            console.error('Error fetching charger firmware list:', error);
            setChargers([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchChargers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTableChange = (paginationConfig) => {
        fetchChargers(paginationConfig.current, paginationConfig.pageSize, serialSearch);
    };

    const handleSearch = (value) => {
        setSerialSearch(value);
        fetchChargers(1, pagination.pageSize, value);
    };

    const columns = [
        {
            title: 'Charger Serial Number',
            dataIndex: 'ChargePointSerialNumber',
            key: 'ChargePointSerialNumber',
        },
        {
            title: 'Latest Firmware Version',
            dataIndex: 'firmwareVersions',
            key: 'latestFirmwareVersion',
            render: (firmwareVersions) => getLatestFirmwareVersion(firmwareVersions) || 'N/A',
        },
    ];

    return (
        <div className="mb-4">
            <h4>Charger Firmware History</h4>
            <Search
                placeholder="Search by charger serial number"
                allowClear
                onSearch={handleSearch}
                style={{ maxWidth: 360, marginBottom: 12 }}
            />
            <Table
                loading={isLoading}
                dataSource={chargers}
                columns={columns}
                rowKey="ChargePointSerialNumber"
                pagination={pagination}
                onChange={handleTableChange}
                expandable={{
                    expandedRowRender: (record) => (
                        <Table
                            dataSource={toFirmwareHistoryRows(record.firmwareVersions)}
                            columns={firmwareHistoryColumns}
                            pagination={false}
                            rowKey="key"
                            size="small"
                        />
                    ),
                }}
                bordered
                size="middle"
            />
        </div>
    );
};

export default PublicChargerFirmwareTable;
